import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let client: SupabaseClient | null = null;

function parseStorageMode(): 'local' | 'session' {
  try {
    const raw = (import.meta as any).env?.VITE_AUTH_STORAGE ?? 'local';
    const v = String(raw).toLowerCase();
    return v === 'session' ? 'session' : 'local';
  } catch {
    return 'local';
  }
}

export function getSupabase(): SupabaseClient {
  if (client) return client;
  if (typeof window === 'undefined') {
    throw new Error('Supabase client can only be created in the browser');
  }

  const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL as string | undefined;
  const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY as string | undefined;
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file');
  }

  const mode = parseStorageMode();
  const storage = mode === 'local' ? window.localStorage : window.sessionStorage;
  const storageKey = `lumi.auth.v1.${(import.meta as any).env?.MODE ?? 'development'}`;

  client = createClient(String(supabaseUrl), String(supabaseAnonKey), {
    auth: {
      // Keep implicit flow for magic links as before
      flowType: 'implicit',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage,
      storageKey,
    },
  });

  return client;
}
